<template>
  <div class="user-center__dynamic-edit-container user-center__common-child-container">
    <div class="dynamic-edit__wrapper center-common-form-wrapper">
      <!-- 顶部 -->
      <sub-page-header>
        <template #title>
          <router-link
            tag="div"
            :to="nav.url"
            active-class="active"
            class="title__front-item"
            v-for="(nav, index) in breadcrumbs"
            :key="index"
            >{{ nav.name }}</router-link
          >
        </template>
        <template #hint>
          <p>
            为保证上架速度，请保证设计包完整度及真实性，带有<i class="circle"></i>的项目是必填的项目
          </p>
        </template>
      </sub-page-header>
      <!-- form部分 -->
      <user-form
        :form="form"
        :rules="rules"
        :render="renderItems"
        ref="postForm"
        @formValidated="onSubmit"
        @formValidateError="onFormError"
      >
        <template #bts>
          <el-button
            v-for="(bt, btindex) in renderBts"
            :key="btindex"
            class="bt__item"
            :class="[bt.type === 'submit' ? 'bt__submit' : 'bt__cancel', bt.classes]"
            @click="bt.onClick && bt.onClick(bt.extendParams, $event)"
            :data-index="btindex"
            :loading="Number(btCurrentIndex) === Number(btindex) && loading"
            :disabled="Number(btCurrentIndex) !== Number(btindex) && loading"
            >{{ bt.label }}</el-button
          >
        </template>
      </user-form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { create } from '@/api/dynamic';
import { molds } from '@/api/common';
import SubPageHeader from '../_pageHeader.vue';
import UserForm from '../_form.vue';

export default {
  components: {
    SubPageHeader,
    UserForm,
  },
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  computed: mapState({
    molds: (state) => state.molds,
    isNew() {
      return !this.id;
    },
  }),
  data() {
    return {
      loading: false,
      btCurrentIndex: -1,
      breadcrumbs: [
        {
          name: '发布动态',
          url: '/my/dynamic/edit/',
        },
      ],
      form: {
        content: '',
        mold_id: '',
        mold_ids: [],
        picture_ids: [],
        loading: false,
      },
      rules: {
        content: [
          {
            required: true,
            message: '请填写内容详情',
            trigger: 'blur',
          },
        ],
        mold_id: [
          {
            required: true,
            message: '请选择分类',
            trigger: 'change',
          },
        ],
        mold_ids: [
          {
            required: true,
            message: '请选择子分类',
            trigger: 'change',
          },
        ],
        picture_ids: [
          {
            required: true,
            message: '请上传图片',
            trigger: 'change',
          },
        ],
      },
      renderItems: {
        content: {
          type: 'textarea',
          maxlength: 200,
          title: '内容详情',
          hint: '发布内容，限200字以内',
        },
        mold_id: {
          type: 'select',
          placeholder: '请选择分类',
          title: '分类',
          hint: '请选择该动态的分类',
          options: this.molds || [],
          onChange: this.moldOnChange,
        },
        mold_ids: {
          type: 'checkbox',
          title: '子分类',
          hint: '请选择该动态的子分类',
          options: [],
          loading: false,
        },
        picture_ids: {
          fileList: [],
          type: 'img',
          title: '上传产品图片',
          hint: '支持上传jpg/png/gif格式，不超过10M，最多9张',
          limit: 9,
        },
      },
      renderBts: [
        {
          label: '发布动态',
          type: 'submit',
          onClick: this.onValidate,
        },
        {
          label: '取消',
          type: 'cancel',
          onClick: this.onCancel,
        },
      ],
    };
  },
  watch: {
    molds(val) {
      this.renderItems.mold_id.options = val;
    },
  },
  created() {
    this.renderItems.mold_id.options = this.molds || [];
  },
  methods: {
    init() {},
    onValidate(extendParams, e) {
      const target = e.currentTarget;
      const { index } = target.dataset;
      this.btCurrentIndex = index;
      this.loading = true;
      this.$refs.postForm.onFormValidate();
    },
    onCancel() {
      this.$router.go(-1);
    },
    onSubmit(val) {
      const that = this;
      create(val).then((res) => {
        if (res.success) {
          that.$message({
            type: 'success',
            message: '动态发布成功！',
            duration: 1000,
            onClose() {
              that.$router.push({
                path: '/search/dynamic',
              });
            },
          });
        }
      });
      this.loading = false;
    },
    moldOnChange(id) {
      this.getChildMolds(id);
    },
    async getChildMolds(id) {
      this.renderItems.mold_ids.loading = true;
      const res = await molds(id);
      const { list } = res.data;
      this.renderItems.mold_ids.options = list;
      this.renderItems.mold_ids.loading = false;
    },
    onFormError(err) {
      console.log(err);
      this.loading = false;
    },
  },
};
</script>

<style></style>
